import n from "classnames";
import { gridElement as a } from "./Grid.css.js";
import { jsx as c } from "react/jsx-runtime";
function N(s) {
  const {
    element: o,
    children: i,
    className: m,
    attributes: l
  } = s, {
    cols: t,
    mobile_hide: d,
    desktop_hide: r,
    customAttributes: e
  } = o;
  return /* @__PURE__ */ c("div", {
    ...e,
    className: n(m, {
      "mobile:hidden": d,
      "desktop:hidden": r
    }, a, e == null ? void 0 : e.className),
    style: {
      "--cols": t
    },
    ...l,
    children: i
  });
}
export {
  N as GridElement
};
